import React, { useEffect } from 'react';
import { MdOutlineEmail } from 'react-icons/md';
import { BiUser, BiChevronRight } from 'react-icons/bi';
import '../../styles/Admin/adminDashboard.css';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

export default function AdminHome({
    adminData,
    alumniCount,
    announcementsCount,
    jobPostsCount,
    eventsCount,
    alumni,
    events,
    announcements,
    jobPosts,
    setPage,
    fetchAlumniById,
    fetchAnnouncementById,
    fetchJobPostById,
    fetchEventById,
}) {
    const navigate = useNavigate();

    useEffect(() => {
        // 👇️ apply a class to main top nav bar to hide it
        let mainNavBar = document.querySelector('._3drDv.MainNavBar');
        if (mainNavBar) mainNavBar.style.display = 'none';

        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, []);

    return (
        <div className='admin-dashboard'>
            <div className='admin-dashboard-header-backImage'>
                <div className='admin-dashboard-header'>
                    <div className='admin-dashboard-header-left'>
                        <div className='admin-profile-pic-container'>
                            <img
                                alt='admin-profile-pic'
                                src={require('../../images/profile-pictures/face2.jpg')}
                                className='admin-profile-pic'
                            />
                        </div>
                    </div>

                    <div className='admin-dashboard-header-right'>
                        <div className='admin-fullname-container'>
                            <BiUser size={35} />
                            <span className='admin-fullname'>
                                {adminData?.firstName} {adminData?.lastName || 'Admin'}
                            </span>
                        </div>

                        <span className='admin-username'>@{adminData?.username || 'username'}</span>

                        <div className='admin-email-container'>
                            <MdOutlineEmail size={35} />
                            <span className='admin-email'>{adminData?.email || 'email'}</span>
                        </div>
                    </div>
                </div>
            </div>

            <div className='admin-dashboard-overview'>
                <h1 className='admin-dashboard-overview-title'>Overview</h1>

                <div className='admin-dashboard-overview-items'>
                    <div className='admin-dashboard-overview-item'>
                        <h1 className='admin-dashboard-overview-item-title'>Alumni</h1>
                        <span className='admin-dashboard-overview-item-value'>
                            {alumniCount > 100 ? alumniCount + '+' : alumniCount}
                        </span>
                    </div>

                    <div className='admin-dashboard-overview-item'>
                        <h1 className='admin-dashboard-overview-item-title'>Announcements</h1>
                        <span className='admin-dashboard-overview-item-value'>
                            {announcementsCount > 100
                                ? announcementsCount + '+'
                                : announcementsCount}
                        </span>
                    </div>

                    <div className='admin-dashboard-overview-item'>
                        <h1 className='admin-dashboard-overview-item-title'>Job Posts</h1>
                        <span className='admin-dashboard-overview-item-value'>
                            {jobPostsCount > 100 ? jobPostsCount + '+' : jobPostsCount}
                        </span>
                    </div>

                    <div className='admin-dashboard-overview-item'>
                        <h1 className='admin-dashboard-overview-item-title'>Events</h1>
                        <span className='admin-dashboard-overview-item-value'>
                            {eventsCount > 100 ? eventsCount + '+' : eventsCount}
                        </span>
                    </div>

                    {/* <div className='admin-dashboard-overview-item'>
                        <h1 className='admin-dashboard-overview-item-title'>Website Views</h1>
                        <span className='admin-dashboard-overview-item-value'>50+</span>
                    </div> */}
                </div>
            </div>

            <div className='admin-dashboard-content'>
                <div className='admin-dashboard-content-alumni'>
                    <div
                        className='alumni-header-container'
                        onClick={() => navigate('/admin.console/alumni')}
                    >
                        <span className='alumni-header-text'>Alumni Table</span>
                        <BiChevronRight size={35} style={{ marginLeft: '1.2rem' }} />
                    </div>

                    <div className='alumni-table-container'>
                        <table style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>uuid</th>
                                    <th>username</th>
                                    <th>email</th>
                                    <th>first name</th>
                                    <th>last name</th>
                                    <th>class</th>
                                    <th>mobile</th>
                                    <th>suspended</th>
                                    <th>position</th>
                                    <th>created on</th>
                                </tr>
                            </thead>
                            <tbody>
                                {alumni?.length > 0 ? (
                                    alumni?.slice(0, 6)?.map((item, index) => (
                                        <tr
                                            key={`row-#${index}-${item?.id}`}
                                            onClick={() => fetchAlumniById(item?.uuid)}
                                        >
                                            <td>{item?.id}</td>
                                            <td>{item?.uuid}</td>
                                            <td>{item?.username}</td>
                                            <td>{item?.email}</td>
                                            <td>{item?.firstName}</td>
                                            <td>{item?.lastName}</td>
                                            <td>{item?.classYear}</td>
                                            <td>{item?.mobile}</td>
                                            <td>{item?.suspended ? 'True' : 'False'}</td>
                                            <td>{item?.positionName}</td>
                                            <td>{moment(new Date(item?.createdAt)).calendar()}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <td
                                        style={{ fontSize: '1.2rem', fontWeight: '600' }}
                                        colSpan={9}
                                    >
                                        No data...
                                    </td>
                                )}
                            </tbody>
                        </table>

                        <div className='more-alumni-text-container'>
                            {alumni?.slice(6)?.length > 0 && (
                                <span
                                    className='more-alumni-text'
                                    onClick={() => navigate('/admin.console/alumni')}
                                >
                                    {' '}
                                    ...and {alumni?.slice(6)?.length} more{' '}
                                </span>
                            )}
                        </div>
                    </div>

                    {/*  */}
                    {/*  */}

                    <div
                        className='alumni-header-container'
                        onClick={() => navigate('/admin.console/events')}
                    >
                        <span className='alumni-header-text'>Events Table</span>
                        <BiChevronRight size={35} style={{ marginLeft: '1.2rem' }} />
                    </div>

                    <div className='alumni-table-container'>
                        <table style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>uuid</th>
                                    <th>name</th>
                                    <th>color</th>
                                    <th>start date</th>
                                    <th>end date</th>
                                    <th>subscribers</th>
                                    <th>details</th>
                                    <th>priority</th>
                                    <th>posted on</th>
                                </tr>
                            </thead>
                            <tbody>
                                {events?.length > 0 ? (
                                    events?.slice(0, 6)?.map((item, index) => (
                                        <tr
                                            key={`row-#${index}-${item?.id}`}
                                            onClick={() => fetchEventById(item?.uuid)}
                                        >
                                            <td>{item?.id}</td>
                                            <td>{item?.uuid}</td>
                                            <td>{item?.name}</td>
                                            <td>{item?.color}</td>
                                            <td>{moment(new Date(item?.startDate)).calendar()}</td>
                                            <td>{moment(new Date(item?.endDate)).calendar()}</td>
                                            <td>{item?.subscribers}</td>
                                            <td>{item?.details}</td>
                                            <td>{item?.priority}</td>
                                            <td>{moment(new Date(item?.createdAt)).calendar()}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <td
                                        style={{ fontSize: '1.2rem', fontWeight: '600' }}
                                        colSpan={10}
                                    >
                                        No data...
                                    </td>
                                )}
                            </tbody>
                        </table>

                        <div className='more-alumni-text-container'>
                            {announcements?.slice(6)?.length > 0 && (
                                <span
                                    className='more-alumni-text'
                                    onClick={() => navigate('/admin.console/announcements')}
                                >
                                    {' '}
                                    ...and {announcements?.slice(6)?.length} more{' '}
                                </span>
                            )}
                        </div>
                    </div>

                    {/*  */}
                    {/*  */}

                    <div
                        className='alumni-header-container'
                        onClick={() => navigate('/admin.console/announcements')}
                    >
                        <span className='alumni-header-text'>Announcements Table</span>
                        <BiChevronRight size={35} style={{ marginLeft: '1.2rem' }} />
                    </div>

                    <div className='alumni-table-container'>
                        <table style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>uuid</th>
                                    <th>title</th>
                                    <th>details</th>
                                    <th>priority</th>
                                    <th>posted on</th>
                                </tr>
                            </thead>
                            <tbody>
                                {announcements?.length > 0 ? (
                                    announcements?.slice(0, 6)?.map((item, index) => (
                                        <tr
                                            key={`row-#${index}-${item?.id}`}
                                            onClick={() => fetchAnnouncementById(item?.uuid)}
                                        >
                                            <td>{item?.id}</td>
                                            <td>{item?.uuid}</td>
                                            <td>{item?.title}</td>
                                            {/* <td className='details'>
                                                {item?.details?.substring(0, 60)}
                                            </td> */}
                                            <td className='details'>{item?.details}</td>
                                            <td>{item?.priority}</td>
                                            <td>{moment(new Date(item?.createdAt)).calendar()}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <td
                                        style={{ fontSize: '1.2rem', fontWeight: '600' }}
                                        colSpan={6}
                                    >
                                        No data...
                                    </td>
                                )}
                            </tbody>
                        </table>

                        <div className='more-alumni-text-container'>
                            {announcements?.slice(6)?.length > 0 && (
                                <span
                                    className='more-alumni-text'
                                    onClick={() => navigate('/admin.console/announcements')}
                                >
                                    {' '}
                                    ...and {announcements?.slice(6)?.length} more{' '}
                                </span>
                            )}
                        </div>
                    </div>

                    <div
                        className='alumni-header-container'
                        onClick={() => navigate('/admin.console/jobposts')}
                    >
                        <span className='alumni-header-text'>Job Posts Table</span>
                        <BiChevronRight size={35} style={{ marginLeft: '1.2rem' }} />
                    </div>

                    <div className='alumni-table-container'>
                        <table style={{ width: '100%' }}>
                            <thead>
                                <tr>
                                    <th>id</th>
                                    <th>uuid</th>
                                    <th>email</th>
                                    <th>company name</th>
                                    <th>required position</th>
                                    <th>employees wanted</th>
                                    <th>redirect url</th>
                                    <th>details</th>
                                    <th>qualifications</th>
                                    <th>expires on</th>
                                    <th>posted on</th>
                                </tr>
                            </thead>
                            <tbody>
                                {jobPosts?.length > 0 ? (
                                    jobPosts?.slice(0, 6)?.map((item, index) => (
                                        <tr
                                            key={`row-#${index}-${item?.id}`}
                                            onClick={() => fetchJobPostById(item?.uuid)}
                                        >
                                            <td>{item?.id}</td>
                                            <td>{item?.uuid}</td>
                                            <td>{item?.email}</td>
                                            <td>{item?.companyName}</td>
                                            <td>{item?.positionName}</td>
                                            <td>{item?.count}</td>
                                            <td>{item?.redirectUrl}</td>
                                            <td>{item?.details}</td>
                                            <td>{item?.qualifications}</td>
                                            <td>{item?.dueDate}</td>
                                            <td>{moment(new Date(item?.createdAt)).calendar()}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <td
                                        style={{ fontSize: '1.2rem', fontWeight: '600' }}
                                        colSpan={10}
                                    >
                                        No data...
                                    </td>
                                )}
                            </tbody>
                        </table>

                        <div className='more-alumni-text-container'>
                            {jobPosts?.slice(6)?.length > 0 && (
                                <span
                                    className='more-alumni-text'
                                    onClick={() => navigate('/admin.console/jobposts')}
                                >
                                    {' '}
                                    ...and {jobPosts?.slice(6)?.length} more{' '}
                                </span>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
